function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMetamaskFox = function SvgMetamaskFox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#e17726",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#e17726",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m32.959.999-13.135 9.719 2.442-5.727Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#e27625",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#e27625",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m2.661.999 13.018 9.81-2.325-5.818ZM28.228 23.535l-3.492 5.335 7.48 2.063 2.144-7.283ZM1.274 23.65l2.13 7.283 7.47-2.063-3.481-5.335Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#e27625",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#e27625",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M10.469 14.516 8.394 17.65l7.402.336-.244-7.97ZM25.151 14.516l-5.156-4.59-.17 8.061 7.406-.336ZM10.874 28.87l4.482-2.163L11.5 23.7ZM20.264 26.707l4.472 2.163-.61-5.17Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#d5bfb2",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#d5bfb2",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m24.736 28.87-4.472-2.163.366 2.905-.04 1.229ZM10.874 28.87l4.155 1.97-.024-1.228.351-2.905Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#233447",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#233447",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m15.107 21.785-3.715-1.09 2.627-1.203ZM20.513 21.785l1.089-2.293 2.641 1.202Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#cc6228",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#cc6228",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m10.874 28.87.65-5.335-4.131.115ZM24.097 23.535l.64 5.335 3.49-5.22ZM27.231 17.65l-7.407.337.689 3.798 1.089-2.293 2.641 1.202ZM11.392 20.694l2.627-1.202 1.088 2.293.689-3.798-7.402-.336Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#e27525",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#e27525",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m8.394 17.65 3.105 6.05-.107-3.006ZM24.243 20.694l-.117 3.006 3.105-6.05ZM15.796 17.987l-.689 3.798.87 4.484.195-5.911ZM19.824 17.987l-.366 2.357.186 5.925.869-4.484Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#f5841f",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#f5841f",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m20.513 21.785-.87 4.484.62.438 3.863-3.007.117-3.006ZM11.392 20.694l.107 3.006 3.857 3.007.62-.438-.869-4.484Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#c0ac9d",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#c0ac9d",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m20.59 30.84.04-1.228-.337-.286h-4.966l-.322.286.024 1.229-4.155-1.97 1.455 1.192 2.95 2.035h5.053l2.959-2.035 1.445-1.193Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#161616",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#161616",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m20.264 26.707-.62-.438h-3.667l-.62.438-.352 2.905.322-.286h4.966l.337.286Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#763e1a",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#763e1a",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m33.516 11.353 1.103-5.363L32.96.999l-12.695 9.396 4.887 4.12 6.9 2.008 1.518-1.777-.664-.479 1.055-.957-.806-.622 1.05-.806ZM1.001 5.99l1.118 5.363-.718.53 1.065.805-.806.622 1.055.957-.664.479 1.523 1.777 6.895-2.007 4.887-4.12L2.661.998Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#f5841f",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#f5841f",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m32.05 16.523-6.899-2.007 2.08 3.135-3.105 6.05 4.102-.051h6.132ZM10.469 14.516l-6.895 2.007-2.3 7.127h6.119l4.106.05-3.105-6.05ZM19.824 17.987l.44-7.592 2.002-5.404h-8.912l2.002 5.404.44 7.592.17 2.385.01 5.897h3.668l.01-5.897Zm0 0",
    transform: "scale(.8 .84849)"
  }));
};
export default SvgMetamaskFox;